import React, { useContext, useState } from "react";
import { Request, UseMe } from "../../api/users/Me.api";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { AuthContext } from "../../context/auth/AuthContext";

const EditProfileContainer = ({ children, initialValues }) => {
  const { token } = useContext(AuthContext);
  const { content, error, loading } = UseMe(token);

  const [editError, setEditError] = useState(null);
  const [editLoading, setEditLoading] = useState(false);

  const onSubmit = (values, actions) => {
    setEditError(null);
    setEditLoading(true);

    let params = values;
    if (!values.profile) {
      params.profile = content;
    }
    Request.updateMe(token.access, { ...params, ...params.profile })
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };
  const onSuccess = (data, actions) => {
    actions.setSubmitting(false);
    setEditLoading(false);
  };

  const onFailure = (error, actions) => {
    setEditError(error);
    setEditLoading(false);
    actions.setSubmitting(false);
  };

  return (
    <>
      {editError ? <Error message={editError} /> : null}
      {error ? <Error message={error} /> : null}
      {loading || editLoading ? <Loading /> : loading}
      {content ? children({ onSubmit, content, initialValues }) : null}
    </>
  );
};

export default EditProfileContainer;
